var $ca0b657aacceb9fd$exports = {};
$ca0b657aacceb9fd$exports = {
    "maximum": `Maksimi`,
    "minimum": `Minimi`
};


export {$ca0b657aacceb9fd$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
